import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from './../actions';
import Forbidden from './../components/Forbidden';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    auth:state.auth,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Forbidden);